/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { RESERVATION_STATE_VALUES } from "../constants";

const useSpaceReservationState = ({
	finalized, updateActivityPopup
}) => {
    const [value, setValue] = useState(0);
	useEffect(() => {
        updateActivityPopup.mustConfirm.set(value !== convertToReservationState());
    }, [value]);
	useEffect(() => {
        if (!updateActivityPopup.popup.value) return;
        readFinalizedState();
    }, [updateActivityPopup.popup.value]);
	function convertToReservationState() {
        if (finalized === null)
            return 0;
        return finalized
            ? RESERVATION_STATE_VALUES.FINALIZED
            : RESERVATION_STATE_VALUES.ON_USE;
    }
	function readFinalizedState() {
		setValue(hasReservationState ? convertToReservationState() : 0);
	}
	function isChecked(valueToCompare) {
		return value === valueToCompare;
	}
	function hasBeenChanges() {
        return convertToReservationState() === value;
    }
	function hasFinalized() {
		return value === RESERVATION_STATE_VALUES.FINALIZED;
	}
    const hasReservationState = finalized !== null;
	return {
		value,
		change: setValue,
		//change: () => {},
		hasBeenChanges,
		hasFinalized,
		hasState: hasReservationState,
		isChecked
	};
}

export default useSpaceReservationState;